module.exports = __webpack_public_path__ + "img/pexels-aaron-ulsh-2860705.462aeee8.png";